var React = require('react');

function NotificationInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"#000","strokeLinecap":"square","strokeLinejoin":"round","strokeWidth":"2","d":"M9 18a3 3 0 0 0 6 0m4-8c0-3.6-3.3-7-7-7s-7 3.4-7 7c0 4.7-1 3.2-2 5-.7 1.2 0 3 1 3h16c1 0 1.7-1.8 1-3-1-1.8-2-.3-2-5z"}));
}

NotificationInline.defaultProps = {"width":"24","height":"24"};

module.exports = NotificationInline;

NotificationInline.default = NotificationInline;
